import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admisiones-barra',
  standalone: false,
  template: `
  <div class="header-mainInfo">
      <h1 class="">Admisiones</h1>
  </div>`,
})
export class AdmisionesBarraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
